window.initTiles ?? (() => {
    window.initTiles = (section_id) => {

        const scrollToSection = () => {
            const links = document.querySelectorAll(`section#shopify-section-${section_id} .careline-20-tiles .tile.is-link`);

            links.forEach(link => {
                link.addEventListener('click', (e) => {
                    console.log(e);
                    if(e.currentTarget.dataset.link.indexOf('#') == 0) {
                        document.querySelector(e.currentTarget.dataset.link).scrollIntoView({
                            behavior: 'smooth'
                        });
                    } else {
                        document.location = e.currentTarget.dataset.link;
                    }
                });
            });
        }

        scrollToSection();

    }
})();